// extracted by mini-css-extract-plugin
export default {"canvas":"wiggle_canvas__uA5eS"};